import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import {
    Col, Row, Form, FormGroup, Button
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ResetMail } from '../../../../redux/Action/Auth/ForgetAction'
// import Teacher from '../../../assets/Images/TeacherLogo.png'
// import Assistant from '../../../assets/Images/AssistantLogo.png'
// import Student from '../../../assets/Images/StudentLogo.png'
// import Parent from '../../../assets/Images/ParentLogo.png'
// import RenderField from '../../../../components/Fields/fields'
// import String from '../../../../assets/Locales/teacher_locales';
// import { Inputs } from './inputSettings'
import validate from './validation';
import RenderField from '../../../../components/Fields/fields'
import String from '../../../../assets/Locales/teacher_locales';
import { Inputs } from './inputSettings'
import LoadingBar from 'react-redux-loading-bar'
// import '../Login/login.css'

class Login extends Component {
    onSubmit = (values) => {
        // console.log(values)
        let code = {
            email: JSON.parse(localStorage.getItem('sendEmail')).email,
            code: values.code,
            type: JSON.parse(localStorage.getItem('sendEmail')).type
        }
        console.log("COODE", code, localStorage.getItem('sendEmail'), localStorage.getItem('sendEmail').type )
        this.props.ResetMail(code, localStorage.getItem('Language'))
    }
    render() {
        // if (this.props.verified) {
        //     return (
        //         <Redirect to="/login" />
        //     )
        // }
        let lang = localStorage.getItem("Language");
        console.log("Language in cerification:", lang)
        if (lang) {
            String.setLanguage(localStorage.getItem("Language"));
        } else {
            lang = "ar"
            String.setLanguage("ar");
        }
        const { handleSubmit, submitting } = this.props
        return (
            <Col lg="4" md="6" style={{ margin: 'auto', marginTop: '8%' }}>

                        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            {
                                Inputs.map((row, index) => {
                                    return (
                                        <FormGroup>
                                            {
                                                row.map((element, index) => {
                                                    return (
                                                        <Field
                                                            lang={lang}
                                                            type={element.type}
                                                            name={element.name}
                                                            component={RenderField}
                                                            label={lang === "ar" ? element.label.ar : element.label.en}
                                                            placeholder={element.placeholder}
                                                            options={element.options}
                                                            optionTitle={element.optionTitle ? (lang === "ar" ? element.optionTitle.ar : element.optionTitle.en) : ""}
                                                        // title={lang === "ar" ? element.title.ar : element.title.en}
                                                        />
                                                    )
                                                })

                                            }
                                        </FormGroup>
                                    )
                                })
                            }
                            <Col md="12" className="login-submit-Btn" style={{ marginTop: '10%' }} id="loginBtn">
                                <Button type="submit" className="btn submitBtn" disabled={submitting}> {String.send}  </Button>
                            </Col>
                        </Form>

                    </Col>

        )
    }
}
const mapStateToProps = state => {
    return {
        verified: state.login.verified
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        ResetMail
    }
    , dispatch
)
export default reduxForm({
    form: 'fieldLevelValidation',
    validate
})(connect(mapStateToProps, mapDispatchToProps)(Login));